import { render, staticRenderFns } from "./LsvaDashboardVehiclesTable.vue?vue&type=template&id=babbd7c2&scoped=true&"
import script from "./LsvaDashboardVehiclesTable.vue?vue&type=script&lang=js&"
export * from "./LsvaDashboardVehiclesTable.vue?vue&type=script&lang=js&"
import style0 from "./LsvaDashboardVehiclesTable.vue?vue&type=style&index=0&id=babbd7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babbd7c2",
  null
  
)

/* custom blocks */
import block0 from "./LsvaDashboardVehiclesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports